import { Combobox, DropdownSelect, FormField, FormHelp, Label } from '@zillow/constellation-10';

type Option = {
  value: number;
  label: string;
};

type Props = {
  value: number;
  onChange: (value: number) => void;
  fieldLabel: string;
  formHelpText?: string;
  required?: boolean;
  onBlur?: (fieldName: string, value: number) => void;
  errorMessage?: string;
  fieldName: string;
};

const MaxOccurrencesField = ({
  value = 0,
  onChange,
  fieldLabel,
  formHelpText = '',
  required = false,
  onBlur = () => {},
  errorMessage = '',
  fieldName,
}: Props) => {
  // Create options with empty option first, then 1-25
  const options: Array<Option> = [{ value: 0, label: '\u00A0' }];
  for (let i = 1; i <= 25; i++) {
    options.push({
      value: i,
      label: i.toString(),
    });
  }

  const onSelectChange = (option: string | { value: string; label: string }) => {
    const selectedValue = typeof option === 'string' ? option : option.value;
    const numericValue = parseInt(selectedValue, 10);
    onChange(numericValue);
    // validate new value on selection to clear out the empty state error right away for better UX
    onBlur(fieldName, numericValue);
  };

  return (
    <FormField
      required={required}
      error={errorMessage !== ''}
      description={<FormHelp>{errorMessage ? errorMessage : formHelpText}</FormHelp>}
      label={<Label>{fieldLabel}</Label>}
      onBlur={(e: React.FocusEvent<HTMLInputElement>) => {
        const numericValue = parseInt(e.target.value, 10);
        onBlur(fieldName, isNaN(numericValue) ? 0 : numericValue);
      }}
    >
      <DropdownSelect
        value={value.toString()}
        placeholder="Select"
        options={options.map((option) => ({
          value: option.value.toString(),
          label: option.label,
        }))}
        renderInput={(renderProps) => {
          const { ref, ...adornmentPropsWithoutRef } = renderProps;
          return (
            <Combobox.Input {...adornmentPropsWithoutRef} data-testid={`CostsAndFeesFields-${fieldName}Dropdown`} />
          );
        }}
        showLabelForValue={true}
        onOptionSelect={onSelectChange}
      />
    </FormField>
  );
};

export default MaxOccurrencesField;
